import { createSelector } from '@reduxjs/toolkit';

import { filtersSelector } from './dumb';

export const isCommercialSelector = createSelector(filtersSelector, filters => {
  return filters._type.startsWith('commercial');
});
